import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { getStudentAchievements, BADGE_DEFINITIONS } from '../services/activityService';
import './AchievementBadges.css';

const AchievementBadges = () => {
  const { currentUser } = useUser();
  const [earnedKeys, setEarnedKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openTooltipKey, setOpenTooltipKey] = useState(null);

  useEffect(() => {
    if (!currentUser) return;
    setIsLoading(true);
    getStudentAchievements(currentUser.id).then(({ data }) => {
      setEarnedKeys(data || []);
      setIsLoading(false);
    });
  }, [currentUser]);

  useEffect(() => {
    if (!openTooltipKey) return;
    const handleOutside = (e) => {
      if (!e.target.closest('.badge-info')) setOpenTooltipKey(null);
    };
    document.addEventListener('click', handleOutside);
    return () => document.removeEventListener('click', handleOutside);
  }, [openTooltipKey]);

  if (isLoading) {
    return (
      <div className="achievements-container">
        <h2>Your Achievements</h2>
        <p style={{ textAlign: 'center', padding: '2rem' }}>Loading achievements...</p>
      </div>
    );
  }

  const badges = BADGE_DEFINITIONS.map((b) => ({ ...b, unlocked: earnedKeys.includes(b.key) }));
  const unlockedCount = badges.filter((b) => b.unlocked).length;

  return (
    <div className="achievements-container">
      <h2>Your Achievements</h2>

      <div className="progress-summary">
        <p>You've earned {unlockedCount} of {badges.length} badges</p>
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${(unlockedCount / badges.length) * 100}%` }}
          ></div>
        </div>
      </div>

      <div className="badges-grid">
        {badges.map((badge) => (
          <div key={badge.key} className={`badge-card ${badge.unlocked ? 'unlocked' : 'locked'}`}>
            <div className="badge-info">
              <span
                className="badge-info-icon"
                aria-label={`How to earn ${badge.label}`}
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenTooltipKey(openTooltipKey === badge.key ? null : badge.key);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setOpenTooltipKey(openTooltipKey === badge.key ? null : badge.key);
                  }
                }}
              >ℹ</span>
              <div
                className={`badge-tooltip ${openTooltipKey === badge.key ? 'tooltip-visible' : ''}`}
                role="tooltip"
              >
                {badge.description}
              </div>
            </div>
            <div className="badge-icon">
              <i className={badge.icon}></i>
            </div>
            <div className="badge-name">{badge.label}</div>
            <div className="badge-status">{badge.unlocked ? 'Unlocked' : 'Locked'}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AchievementBadges;
